import { create } from "zustand";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { addToCartapi, getCartapi, updateQuantityapi } from "../api/cart";


export const useCartStore = create((set, get) => ({
    cart: [],
    coupon: null,
    total: 0,
    totalCartItem: 0,
    subtotal: 0,
    isCouponApplied: false,


    getCart: async (pageNumber, pageSize, search, field) => {
        set({ loading: true })
        try {
            const res = await getCartapi(pageNumber, pageSize, search, field)
            set({
                loading: false,
                cart: res?.ref,
                total: res?.totalAmount || 0,
                totalCartItem: res?.totalItems || 0
            })
            // console.log("cart1", res)
            return res?.ref
        } catch (error) {
            console.error("Login failed:", error);
            set({ loading: false });
            throw error;
        }
    },
    addtoCart: async (product, sizeId, size_attributeId, quantity, color,selectedWeight) => {
        set({ loading: true })
        try {
            const res = await addToCartapi(product, sizeId, size_attributeId, quantity, color,selectedWeight)
            set({ loading: false })
            get().getCart(1, 10, '', '');
            return res
        } catch (error) {
            console.error("Login failed:", error);
            set({ loading: false });
            throw error;
        }
    },
    updateQuantity: async (cartItemId, quantity) => {
        set({ loading: true })
        try {
            const res = await updateQuantityapi(cartItemId, quantity)
            set({ loading: false })
            if (res) {
                set((prev) => ({
                    cart: prev.cart
                        .map((item) =>
                            item._id === cartItemId
                                ? {
                                    ...item,
                                    quantity: item.quantity + quantity,
                                    total: (item.quantity + quantity) * item.price,
                                }
                                : item
                        )
                        .filter((item) => item.quantity > 0),
                }));
            }
            const total = get().calculateTotalPrice()
            console.log(total)
            return res
        } catch (error) {
            console.error("Login failed:", error);
            set({ loading: false });
            throw error;
        }
    },
    calculateTotalPrice: () => {
        set((prev) => {
            const total = prev.cart.reduce(
                (sum, ele) => sum + (+ele?.total || 0),
                0
            );
            return { total };
        });
    },
    resetCart: () => {
        set({
            cart: [],
            coupon: null,
            total: 0,
            totalCartItem: 0,
            subtotal: 0,
            isCouponApplied: false,
        });
    }

}))